import { Drawer } from "@/components";
import { DRAWER_NOTIFICATION_SETTINGS } from "@/const";
import { useResponsiveness } from "@/providers/context";

import { NotificationSettings } from "./NotificationSettings";

export const NotificationSettingsDrawer = (props: {
  title: string;
  titleClassName?: string;
}) => {
  const { openDrawer, setOpenDrawer } = useResponsiveness();

  return (
    <Drawer
      open={openDrawer === DRAWER_NOTIFICATION_SETTINGS}
      onOpenChange={(open) =>
        setOpenDrawer(open ? DRAWER_NOTIFICATION_SETTINGS : "")
      }
      {...props}
    >
      <NotificationSettings />
    </Drawer>
  );
};
